import React, { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { ChevronLeft, MessageCircle, ChevronRight, MapPin, LogIn } from "lucide-react";
import * as ella from "@/lib/ellaApi";
import { useSeo } from "@/lib/seo";
import { LOGO } from "@/lib/ellaApi";
import { useAuth } from "@/lib/auth";

export default function MessagesPage() {
  const nav = useNavigate();
  const ctx = useOutletContext();
  const { isAuthed } = useAuth();
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);

  useSeo({ title: "Pesan" });

  useEffect(() => {
    if (!isAuthed) { setLoading(false); return; }
    ella.getChatList()
      .then((res) => setChats(res.status ? res.data : []))
      .finally(() => setLoading(false));
  }, [isAuthed]);

  if (!isAuthed) {
    return (
      <div className="p-8 text-center pb-32">
        <MessageCircle className="w-16 h-16 text-gray-300 mx-auto mb-3" />
        <h2 className="font-display text-xl font-bold mb-1">Pesan</h2>
        <p className="text-sm text-gray-500 mb-5">Masuk untuk chat dengan admin cabang Ella Froze.</p>
        <button onClick={() => ctx?.openAuth?.()} className="btn-primary px-5 h-11" data-testid="messages-login-button">
          <LogIn className="w-4 h-4 mr-2 inline" /> Masuk / Daftar
        </button>
      </div>
    );
  }

  return (
    <div className="pb-24">
      <div className="px-4 py-3 flex items-center gap-3 sticky top-[60px] bg-white z-30 border-b border-gray-100">
        <h1 className="font-display text-lg font-bold text-gray-900">Pesan</h1>
      </div>

      <div className="p-4 space-y-2">
        <p className="text-xs text-gray-500 mb-2">Chat langsung dengan admin tiap cabang untuk pertanyaan stok, pesanan, atau bantuan.</p>
        {loading ? (
          Array.from({ length: 5 }).map((_, i) => <div key={i} className="h-16 skeleton rounded-2xl" />)
        ) : chats.length === 0 ? (
          <div className="py-12 text-center text-sm text-gray-500">Belum ada percakapan</div>
        ) : (
          chats.map((c) => (
            <Link
              key={c.ID}
              to={`/messages/${c.ID}`}
              state={{ name: c.Name }}
              className="bg-white rounded-2xl border border-gray-100 p-3 flex items-center gap-3 hover:shadow-sm"
              data-testid={`chat-list-${c.Name.toLowerCase()}`}
            >
              <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center shrink-0">
                <img src={LOGO} alt="" className="w-8 h-8 object-contain" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <p className="font-semibold text-sm text-gray-900">Admin {c.Name}</p>
                  {c.UnreadMessage > 0 && (
                    <span className="text-[10px] font-bold bg-[#D32F2F] text-white px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
                      {c.UnreadMessage}
                    </span>
                  )}
                </div>
                <p className="text-xs text-gray-500 truncate mt-0.5">{c.LastMessage || "Mulai percakapan dengan admin"}</p>
              </div>
              <ChevronRight className="w-4 h-4 text-gray-300 shrink-0" />
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
